import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export default class SelectableRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    disabledMessage: PropTypes.string,
    hideCheckbox: PropTypes.bool,
    responsive: PropTypes.bool,
    selected: PropTypes.bool,
    onChange: PropTypes.func
  };

  static defaultProps = {
    responsive: true,
    onChange: () => {}
  };

  handleChange = (event) => {
    const selected = event.target.checked;
    this.props.onChange(event, selected);
  };

  render() {
    const {
      children,
      className: customRowClass,
      disabled,
      disabledMessage,
      hideCheckbox,
      responsive,
      selected,
      onChange,
      ...rowProps
    } = this.props;

    const rowClass = classNames('selectable-row', customRowClass, { selected });

    // TODO: Clean up - the disabled flag should be all that counts
    const checkboxDisabled = disabled || disabledMessage != null;
    const className = classNames('auto-size row-buffer select-cell', {
      'hidden-xs': responsive,
      'hidden-sm': responsive
    });

    return (
      <tr className={rowClass} {...rowProps}>
        {!hideCheckbox && (
          <td className={className}>
            {disabledMessage ? this.renderCheckboxWithTooltip() : this.renderCheckbox(checkboxDisabled)}
          </td>
        )}
        {children}
      </tr>
    );
  }

  renderCheckbox(disabled) {
    const { selected } = this.props;

    return (
      <input
        checked={selected || false}
        className="checkbox--lg"
        disabled={disabled}
        type="checkbox"
        onChange={this.handleChange}
      />
    );
  }

  renderCheckboxWithTooltip() {
    const { disabledMessage } = this.props;

    const tooltip = (
      <Popover id={'disabled-tooltip'}>
        {disabledMessage}
      </Popover>
    );

    return (
      <OverlayTrigger overlay={tooltip} placement="right">
        <div>
          {this.renderCheckbox(true)}
        </div>
      </OverlayTrigger>
    );
  }
}
